import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { loginRequest } from '@/authConfig';
import { useMsal } from '@/composition-api/useMsal';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { instance } = useMsal();

// const loginRedirect = () => instance.loginRedirect(loginRequest);

const loginPopup = async () => {
  try {
    await instance.loginPopup(loginRequest);
  } catch (err) {
    // handle error
    console.log('login error', err);
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: loginPopup,
    class: "inline-block cursor-pointer leading-8 px-4 py-2 text-white hover:bg-purple"
  }, "Login"))
}
}

})